module.exports = __webpack_public_path__ + "img/finish.4ccf6fc2.jpg";